// extracted by mini-css-extract-plugin
export var chip = "_dq-0";
export var filterDropdown = "_dq-5";
export var filterItem = "_dq-6";
export var icon = "_dq-1";
export var removeButton = "_dq-3";
export var removeIcon = "_dq-4";
export var separator = "_dq-2";